import {Combined, Animatable} from "../../feature/project/Shot";
import {Col, Flex, Row, Space} from "antd";
import React, {useCallback, useEffect} from "react";
import {ElementContainer} from "../shot/editor/ElementContainer";
import {AnimatableElement} from "../shot/editor/AnimatableElement";
import {imageFormats} from "./FilesBrowser";

export const ElementsCollection = (props: {
    elements: Array<Combined & Animatable>,
    onSelect: (element: Combined & Animatable) => void,
    animated: boolean
}) => {
    return (
        <Flex gap={16}>
            <Space direction={'vertical'} style={{
                width: 'calc(100% + 10px)',
                marginLeft: '-5px',
                marginRight: '-10px',
                maxHeight: 340,
                overflowY: 'auto', scrollbarWidth: "none"
            }} size={16}>
                <Row>
                    {props.elements?.filter((e:any) => e.source == undefined || imageFormats.includes(e.source?.split(".").pop() ?? "")).map((element, index) =>
                        <Col span={8}
                             onClick={() => {
                                 props.onSelect(element)
                             }}
                             key={index}
                        >
                            <CollectionElement
                                key={index} element={element} index={index} animated={props.animated}/>
                        </Col>
                    )}
                </Row>
            </Space>
        </Flex>
    )
}

const CollectionElement = (props: {element: Combined & Animatable, index: number, animated: boolean }) => {
    const [play, setPlay] = React.useState(false)
    const [scale, setScale] = React.useState(1)
    const [height, setHeight] = React.useState(0)
    const [width, setWidth] = React.useState(0)

    useEffect(() => {
        setScale(width > height ? width / 1920 : height / 1920)
    }, [width, height, props.element])

    const elementRef = useCallback((node: HTMLDivElement) => {
        if (!node) return;
        const resizeObserver = new ResizeObserver(() => {
            setWidth(node.clientWidth || 0)
            setHeight(node.clientHeight || 0)
        });
        resizeObserver.observe(node);
    }, []);

    return (
        <div

            key={props.index}
            ref={elementRef}
            onMouseEnter={() => setPlay(true)}
            onMouseLeave={() => setPlay(false)}
            style={{
                margin: 5,
                height: width / 1.77,
                background: '#000000',
                overflow: 'hidden',
                position: 'relative',
                borderRadius: 6,
                cursor: 'pointer',
                overflowClipBox: 'content-box'
            }}>
            <ElementContainer
                editable={true}
                style={{
                    width: '100%',
                    height: '100%',
                }}
                static={true}
                key={props.index}
                isSelected={false}
                onSelect={() => {
                }}
                onPositionChanged={() => {
                }}
                element={{...props.element, x: 0, y: 0, z: 0, scale: 1}}
                scale={scale}>

                    {props.element.layers && props.element.layers.length > 0 ?
                        props.element.layers.map(layer => {

                            return <AnimatableElement
                                style={props.animated ? undefined : {
                                    width: '100%',
                                    height: '100%',
                                }}
                                animationStyle={{
                                    width: '100%',
                                    height: '100%',

                                }}
                                element={{...layer, x: 0, y: 0, z: 0, scale: 1}}
                                play={props.animated ? play : false}
                                key={layer.id}
                                scale={scale}
                                animations={layer.animations && layer.animations.length > 0 ? layer.animations : [{id: -1}]}
                                onPlayEnd={(id: number) => {

                                }}
                            >
                                    <img src={layer.source}
                                         draggable={false}
                                         unselectable={'on'}
                                         style = {{
                                             width: !props.animated ? '100%' : undefined,
                                             height: !props.animated ? '100%' : undefined,
                                             objectFit: !props.animated ? 'cover' : undefined,
                                             background: !props.animated ? '#000' : undefined,
                                         }}
                                         />
                            </AnimatableElement>
                        }) : ''
                    }

            </ElementContainer>
            {props.element.title ?
                <div style={{
                    position: 'absolute',
                    background: '#ffffff',
                    borderRadius: 18,
                    padding: '4px 12px',
                    bottom: 10,
                    left: '50%',
                    textWrap: 'nowrap',
                    translate: '-50%',
                    zIndex:1000
                }}>
                    {props.element.title}
                </div> : ''}
        </div>
    )
}
